var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 10H2.75M11.75 14H6.75M2.75 8.2L2.75 15.8C2.75 16.9201 2.75 17.4802 2.96799 17.908C3.15973 18.2843 3.46569 18.5903 3.84202 18.782C4.26984 19 4.82989 19 5.95 19L19.55 19C20.6701 19 21.2302 19 21.658 18.782C22.0343 18.5903 22.3403 18.2843 22.532 17.908C22.75 17.4802 22.75 16.9201 22.75 15.8V8.2C22.75 7.0799 22.75 6.51984 22.532 6.09202C22.3403 5.7157 22.0343 5.40974 21.658 5.21799C21.2302 5 20.6701 5 19.55 5L5.95 5C4.8299 5 4.26984 5 3.84202 5.21799C3.4657 5.40973 3.15973 5.71569 2.96799 6.09202C2.75 6.51984 2.75 7.07989 2.75 8.2Z",
    stroke: "#20263F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPay);
export default __webpack_public_path__ + "static/media/credit_card_pay.4dc3eeb4c6547af2ac5da0cac7099a12.svg";
export { ForwardRef as ReactComponent };